<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("payable", ["paymentLoaderMessage"]),

    title: function() {
      return this.paymentLoaderMessage.title;
    },

    message: function() {
      return this.paymentLoaderMessage.message;
    }
  }
};
</script>

<template>
  <div class="loading">
    <h3>PROCESSANDO O PAGAMENTO</h3>

    <div :class="`loader squeegee`"/>

    <span class="loader-title">
      <b v-html="title"></b>
    </span>

    <span class="loader-message" v-html="message"></span>

    <span class="loader-muted">Isto poderá demorar um pouco...</span>
  </div>
</template>

<style scoped>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h3 {
  text-align: center;
  margin-top: 0;
  margin-bottom: 8px;
  padding-bottom: 16px;
  font-weight: 500;
}

.loader {
  background: #cc006e;
  border-radius: 50%;
  height: 150px;
  overflow: hidden;
  position: relative;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader::before {
  animation: rotateSpinner-loader 4s infinite linear;
  background: rgba(255, 255, 255, 0.4);
  content: "";
  height: 75px;
  left: 0;
  position: absolute;
  top: 0;
  width: 75px;
  -webkit-transform-origin: 75px 75px;
  transform-origin: 75px 75px;
}

.loader::after {
  border-radius: 50%;
  box-shadow: inset 0 0 0 5px #fff;
  content: "";
  height: 130px;
  left: 10px;
  position: absolute;
  top: 10px;
  width: 130px;
}

.loader.squeegee::after {
  background: url("/static/squeegee.gif") no-repeat center;
}

.loader.broom::after {
  background: url("/static/broom.gif") no-repeat center;
}

.loader-title {
  margin-top: 8px;
  font-size: 18px;
  font-weight: 500;
  color: #424242;
  text-align: center;
}

.loader-message {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #6b0085;
  text-align: center;
}

.loader-muted {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}

@keyframes rotateSpinner-loader {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payment/Components/GifLoader.vue